import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { UserInitialIcon } from '../../../components/userInitialIcon/UserInitialIcon';
import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import { formatDate2 } from '../../../utils/dateFormat';
import { AboutMeModel } from './about-me-service';
import { useCreateUpdateAboutMeMutation, useGetAboutMePersonalizationQuery } from './aboutMeSlice';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

type aboutMeProps = {
    hideFunction: () => void;
    loggedUser: string;
};

export const AboutMe = ({ hideFunction, loggedUser }: aboutMeProps) => {
    const empId = useSelector(selectCurrentEmpid);
    const [aboutMe, setAboutMe] = useState<any>([]);
    const [createUpdateAboutMe] = useCreateUpdateAboutMeMutation();
    const [aboutMeDescription, setAboutMeDescription] = useState<string>('');
    const [enableSubmit, setEnableSubmit] = useState<boolean>(false);

    const { data: aboutMeData } = useGetAboutMePersonalizationQuery(
        { employeeNumber: empId },
        { skip: !empId }
    );

    useEffect(() => {
        if (aboutMeData?.data.length > 0) {
            setAboutMe(aboutMeData?.data[0]);
            setAboutMeDescription(aboutMeData?.data[0]?.about_me_description);
        }
    }, [aboutMeData]);

    useEffect(() => {
        const isFormValid = aboutMeDescription !== '';
        setEnableSubmit(isFormValid);
    }, [aboutMeDescription]);

    const Submit = () => {
        if (!aboutMeDescription) {
            toast.error('Please fill all the fields');
            return;
        }

        const aboutMeObj: AboutMeModel = {
            personalizationId: aboutMe?.personalization_id ? aboutMe?.personalization_id : 0,
            empLanguageId: aboutMe?.emp_language_id ? aboutMe?.emp_language_id : null,
            emailAddress: aboutMe?.email_address ? aboutMe?.email_address : '',
            phoneNumber: aboutMe.phone_number ? aboutMe.phone_number : '',
            employeeNumber: empId,
            aboutMeDescription,
        };

        createUpdateAboutMe(aboutMeObj)
            .unwrap()
            .then(() => {
                toast.success('Saved Successfully');
                hideFunction();
            })
            .catch((error: any) => {
                console.error(error);
                toast.error('Saved Failed');
            });
    };

    const handleDescriptionChange = (value: string) => {
        setAboutMeDescription(value);
    };

    return (
        <div>
            <h5 className="mb-3" style={{ fontSize: '24px', fontWeight: '600' }}>
                About Me
            </h5>
            <Divider />
            <div className="row mt-3">
                <div className="col-md-1">
                    <UserInitialIcon user={loggedUser} iHeight="50px" iWidth="50px" iFontSize="20px" />
                </div>
                <div className="col-md-11">
                    <h5 style={{ fontSize: '16px', fontWeight: '600' }}>
                        What do you want others to know about you?
                    </h5>
                    <DescriptionBox
                        responseDescription={aboutMeDescription}
                        value={aboutMeDescription}
                        limit={200}
                        onChange={handleDescriptionChange}
                    />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-md-6">
                    <h6
                        style={{
                            fontWeight: '600',
                            fontSize: '16px',
                        }}
                    >
                        TTEC Start Date
                    </h6>
                    <h6
                        style={{
                            fontWeight: '400',
                            fontSize: '16px',
                        }}
                    >
                        {formatDate2(aboutMe?.hire_date)}
                    </h6>
                </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-3">
                <Button
                    label="Cancel"
                    onClick={hideFunction}
                    className="btn-secondary"
                />
                <Button
                    label="Save"
                    onClick={Submit}
                    disabled={!enableSubmit}
                    className="btn-primary"
                />
            </div>
        </div>
    );
};
